import { render, staticRenderFns } from "./stockItemsUnderLimitTable.vue?vue&type=template&id=93e4f4b2&"
import script from "./stockItemsUnderLimitTable.vue?vue&type=script&lang=ts&"
export * from "./stockItemsUnderLimitTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports